
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DEVICES_BULK_UNPAIRING_REQUEST,
    DEVICES_BULK_SEARCH_DEVICE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { bulkUnpairingResult, bulkUnpairingSetDevice } from 'Redux/actions';


function* bulkUnpairing({ payload }) {
    try {
        const QUERY = `
            mutation bulkUnPairingBatch ($unitIds: [Int]) {
                result: bulkUnPairingBatch (unitIds: $unitIds){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                unitIds: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result){
            yield put(bulkUnpairingResult({ unpairing: data?.result }))
        }

    } catch (exc) {
        yield put(bulkUnpairingResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkUnpairing/redux/saga",
            "bulkUnpairing",
        )
    }
}

function* searchDevice({ payload }) {
    try {
        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        linkedUnitId
                        linkedUnit {
                            id
                            label
                            esn
                            imei
                            linkedUnitId
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: [
                        "esn",
                        "imei"
                    ],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            if (items.length > 0) {
                yield put(bulkUnpairingSetDevice(items))
            } else {
                yield put(bulkUnpairingSetDevice({ error: true }))
            }

        }
    } catch (exc) {
        yield put(bulkUnpairingSetDevice({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/bulkUnpairing/redux/saga",
            "searchDevice",
        )
    }
}

function* watchMethods() {
    yield takeEvery(DEVICES_BULK_UNPAIRING_REQUEST, bulkUnpairing);
    yield takeEvery(DEVICES_BULK_SEARCH_DEVICE_REQUEST, searchDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}